import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-card-stacked .swiper');
const swiperInstances = [];

const initializeSliders = () => {
	if (window.innerWidth >= 768) {
		swiperInstances.forEach((swiperInstance) => {
			swiperInstance.destroy(true, true);
		});

		swiperInstances.length = 0;

		return;
	} else if (swiperInstances.length > 0) {
		return;
	}

	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const slides = slider.querySelectorAll('.swiper-slide');

			const settings = {
				loop: slides.length > 1 ? true : false,
				grabCursor: true,
				spaceBetween: 10,
				slidesPerView: 1,
				slideClass: 'block-card',
				modules: [A11y, Navigation, Pagination],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
				},
				navigation: {
					prevEl: `.swiper-button-prev`,
					nextEl: `.swiper-button-next`,
				},
				pagination: {
					el: `.swiper-pagination`,
					clickable: true,
				},
				breakpoints: {
					576: {
						slidesPerView: 2,
						loop: slides.length > 2 ? true : false,
					},
				},
			};

			swiperInstances.push(new Swiper(slider, settings));
		});
	}
};

initializeSliders();

window.addEventListener('propel-viewport-changed-md', initializeSliders);
window.addEventListener('propel-viewport-changed-lg', initializeSliders);
